/**
 * Returns `true` if error should be shown to the user, `true` does not mean that there are errors,
 * it means that **if** there are errors then they should be shown.
 * @param {WidgetProps<any, any>} props - Widget props.
 * @returns {boolean} Returns `true` if error should be shown to the user.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function shouldShowError(props) {
    var _a, _b, _c, _d;
    const showErrors = !props.editMode && ((_d = (_b = (_a = props.rootParams) === null || _a === void 0 ? void 0 : _a.showErrorsOverride) !== null && _b !== void 0 ? _b : (_c = props.rootParams) === null || _c === void 0 ? void 0 : _c.showErrors) !== null && _d !== void 0 ? _d : 'all');
    return showErrors === 'all' || (showErrors === 'changed' && !!props.internalData.changed);
}
